import React from 'react';
import { Link } from 'react-router-dom';

import './Navbar.scss';

const Navbar = () => (
  <nav className="navbar">
    <Link className="navbar-item" to="/colors">
      Colors
    </Link>
    <Link className="navbar-item" to="/tictactoe">
      Tic Tac Toe
    </Link>
  </nav>
);

export default Navbar;
